import bridge from "@vkontakte/vk-bridge";

async function getVkStorage(param) {
  const response = await bridge.send('VKWebAppStorageGet', {keys: [param]})
  return response.keys[0] && response.keys[0].value
}
export default getVkStorage